import { Col, Input, Row, Select } from "antd";
import React, { useState } from "react";
import { CountryDropdown, RegionDropdown } from "react-country-region-selector";
import { withRouter } from "../../../utils/tms-with-router/tms-with-router";

const TmsPosUserForm = ({
  setDevoteeName,
  devoteeName,
  setGender,
  gender,
  setAge,
  age,
  setPhone,
  phone,
  setEmail,
  email,
  setAddress,
  address,
  setZip,
  zip,
  setCity,
  city,
  setState,
  state,
  setCountry,
  country,
  deviceInfo,
  checkIfDeviceIsReady,
}) => {
  const labelStyles = { float: "left", fontSize: "17px", marginBottom: "5px" };
  const [templeDetails] = useState(
    JSON.parse(localStorage.getItem("templeDetails"))
  );
  return (
    <>
      <Row
        style={{
          fontWeight: "400",
          justifyContent: "space-between",
          fontSize: "20px",
        }}
      >
        <Col>Devotee Details</Col>
        {templeDetails?.configuration?.enableAccommodationFingerScan && (
          <Col
            style={{ display: "flex", flexDirection: "row", fontSize: "18px" }}
          >
            Biometric Device :
            <p
              style={{
                color: `${
                  deviceInfo?.data?.ErrorCode === "0" ? "green" : "red"
                }`,
                marginLeft: "10px",
                fontWeight: "600",
              }}
            >
              {deviceInfo?.data?.ErrorDescription === "Success"
                ? "Connected"
                : "Not Connected"}
            </p>
            {deviceInfo?.data?.ErrorCode !== "0" && (
              <p
                style={{
                  color: "skyblue",
                  textDecoration: "underline",
                  marginLeft: "10px",
                  cursor: "pointer",
                }}
                onClick={() => {
                  checkIfDeviceIsReady();
                }}
              >
                Refresh
              </p>
            )}
          </Col>
        )}
      </Row>
      <br />
      <Row style={{ width: "100%", justifyContent: "space-between" }}>
        <Col style={{ width: "49%" }}>
          <label style={labelStyles}>
            Devotee Name{" "}
            <span style={{ color: "red", marginLeft: "3px" }}>*</span>
          </label>
          <br />{" "}
          <Input
            onChange={(e) => {
              if (
                /^[a-zA-Z ]*$/.test(String(e.target.value)) ||
                e.target.value === ""
              ) {
                setDevoteeName(e.target.value);
              }
            }}
            type="text"
            placeholder="Enter Name"
            maxLength="30"
            value={devoteeName}
          />
        </Col>
        <Col style={{ width: "49%" }}>
          <label style={labelStyles}>
            Age <span style={{ color: "red", marginLeft: "3px" }}>*</span>
          </label>
          <br />{" "}
          <Input
            onKeyDown={(e) =>
              ["e", "E", "+", "-", "."].includes(e.key) && e.preventDefault()
            }
            onChange={(e) => {
              if (e.target.value > 120) {
                return;
              }
              setAge(e.target.value);
            }}
            type="number"
            min="0"
            placeholder="Enter Age"
            value={age}
            onWheel={(event) => event.currentTarget.blur()}
            maxLength={220}
          />
        </Col>
      </Row>
      <br />
      <Row style={{ width: "100%", justifyContent: "space-between" }}>
        <Col style={{ width: "49%" }}>
          <label style={labelStyles}>
            Gender <span style={{ color: "red", marginLeft: "3px" }}>*</span>
          </label>
          <br />{" "}
          <Select
            onChange={(e) => setGender(e)}
            placeholder="Select Gender"
            style={{ width: "100%" }}
            value={gender}
            allowClear
          >
            <Select.Option key="male" value="male">
              Male
            </Select.Option>
            <Select.Option key="female" value="female">
              Female
            </Select.Option>
            <Select.Option key="other" value="other">
              Other
            </Select.Option>
          </Select>
        </Col>
        <Col style={{ width: "49%" }}>
          <label style={labelStyles}>
            Mobile Number{" "}
            <span style={{ color: "red", marginLeft: "3px" }}>*</span>
          </label>
          <br />{" "}
          <Input
            onChange={(e) => {
              if (e.target.value.length > 10) {
                return;
              }
              setPhone(e.target.value);
            }}
            type="number"
            min="0"
            prefix="+91"
            onWheel={(event) => event.currentTarget.blur()}
            maxLength={10}
            value={phone}
            onKeyDown={(e) =>
              ["e", "E", "+", "-", "."].includes(e.key) && e.preventDefault()
            }
          />
        </Col>
      </Row>
      <br />
      <Row style={{ width: "100%", justifyContent: "space-between" }}>
        <Col style={{ width: "49%" }}>
          <label style={labelStyles}>Email ID </label>
          <br />{" "}
          <Input
            type="email"
            placeholder="Enter Email ID"
            maxLength={220}
            value={email}
            onChange={(e) => {
              setEmail(e.target.value);
            }}
          />
        </Col>
        <Col style={{ width: "49%" }}>
          <label style={labelStyles}>
            Address <span style={{ color: "red", marginLeft: "3px" }}>*</span>
          </label>
          <br />{" "}
          <Input
            type="text"
            placeholder="Enter Address"
            maxLength={220}
            onKeyDown={(e) => ["#", "+"].includes(e.key) && e.preventDefault()}
            value={address}
            onChange={(e) => {
              setAddress(e.target.value);
            }}
          />
        </Col>
      </Row>
      <br />
      <Row style={{ width: "100%", justifyContent: "space-between" }}>
        <Col style={{ width: "49%" }}>
          <label style={labelStyles}>
            Pincode
            <span style={{ color: "red", marginLeft: "3px" }}>*</span>
          </label>
          <br />{" "}
          <Input
            type="number"
            min="0"
            onKeyDown={(e) =>
              ["e", "E", "+", "-", "."].includes(e.key) && e.preventDefault()
            }
            onWheel={(event) => event.currentTarget.blur()}
            placeholder="Enter Pincode"
            value={zip}
            onChange={(e) => {
              if (e.target.value.length > 6) {
                return;
              }
              setZip(e.target.value);
            }}
            maxLength={220}
          />
        </Col>
        <Col style={{ width: "49%" }}>
          <label style={labelStyles}>
            City <span style={{ color: "red", marginLeft: "3px" }}>*</span>
          </label>
          <br />{" "}
          <Input
            type="text"
            value={city}
            placeholder="Enter City"
            maxLength={220}
            onChange={(e) => {
              setCity(e.target.value);
            }}
          />
        </Col>
      </Row>
      <br />
      <Row style={{ width: "100%", justifyContent: "space-between" }}>
        <Col style={{ width: "49%" }}>
          <label style={labelStyles}>
            State
            <span style={{ color: "red", marginLeft: "3px" }}>*</span>{" "}
          </label>
          <br />
          <RegionDropdown
            className="CountryRegionDropDown"
            country={country}
            value={state}
            showDefaultOption={true}
            blankOptionLabel="Select State"
            onChange={(val) => {
              setState(val);
            }}
            placeholder="Select State"
          />
        </Col>
        <Col style={{ width: "49%" }}>
          <label style={labelStyles}>
            Country <span style={{ color: "red", marginLeft: "3px" }}>*</span>
          </label>
          <br />{" "}
          <CountryDropdown
            className="CountryRegionDropDown"
            value={country}
            onChange={(val) => {
              setCountry(val);
            }}
          />
        </Col>
      </Row>
    </>
  );
};

export default withRouter(TmsPosUserForm);
